/* eslint-disable react-hooks/exhaustive-deps */
import ms from 'ms';
import { useEffect } from 'react';

import useEventCallback from '../useEventCallback/index.ts';
// Adapted from: https://github.com/siddharthkp/use-timeout/blob/master/index.js

/**
 * Call a callback function after a specified delay
 * @param callback The callback to fire after the specified `delay`
 * @param delay The amount of time until firing the `callback`
 * @param dependencies Any dependencies to reset the timeout for: uses `useEffect` as backend
 */
function useTimeout(
  callback: () => void,
  delay: number | string,
  dependencies: unknown[] = []
): void {
  const time = ms(`${delay}`);
  const tick = useEventCallback(callback);

  useEffect(() => {
    if (!delay) {
      tick();
      return undefined;
    }
    const id = setTimeout(tick, time);

    return () => clearTimeout(id);
  }, [tick, time, ...dependencies]);
}

export default useTimeout;
